import { TAO_KOE, Cookies } from './../libs';

const COOKIE_NAME = 'taoPLLPrefShop';

class LanguagePopup {
	constructor( popupEl ) {
		this.popupEl = popupEl;

		this.popupEl.addEventListener( 'click', ( ev ) => {
			if ( ev.target.closest( '.choose-lang' ) ) {
				ev.preventDefault();
				this.onChooseLang( ev.target );
			}
		} );

		this.popupEl.addEventListener( 'popup_closed.sl', () => {
			if ( ! this.popupEl.returnValue ) {
				const currentEl = this.popupEl.querySelector( '.choose-lang.current' );
				const country = currentEl.dataset.country;

				Cookies.set( COOKIE_NAME, country, { expires: 7, secure: true } ); // User closed the popup, so we save the cookie for 7 days.
				this.popupEl.returnValue = country;
			}
		} );
	}

	open() {
		return TAO_KOE.open_popup( this.popupEl );
	}

	close = function( returnValue = '' ) {
		return TAO_KOE.close_popup( this.popupEl, returnValue );
	};

	onChooseLang( targetEl ) {
		const country = targetEl.dataset.country;
		Cookies.set( COOKIE_NAME, country, { expires: 7, secure: true } ); // User explicitly chose this lang, so we save the cookie for 7 days.

		if ( targetEl.classList.contains( 'current' ) ) {
			// Stay on the current page.
			this.close( country );
		} else if ( targetEl.dataset.transferCookie ) {
			// Set CrossDomain Cookie so the Popup does not get displayed again.
			// Set Callback for after the fetch to always transfer to new domain.
			const transfer = () => {
				window.location.href = targetEl.getAttribute( 'href' );
			};

			const settings = {
				credentials: 'include',
				mode: 'no-cors',
			};

			// Add loading indicator.
			this.popupEl.querySelectorAll( '.choose-lang' ).forEach( ( buttonEl ) => buttonEl.classList.toggle( 'en_button--loading', buttonEl === targetEl ) );

			// Get new cookie via fetch -> then transfer away.
			fetch( targetEl.dataset.transferCookie, settings ).then( transfer, transfer ).finally(
				// Remove loading spinner after 10 seconds, something may have gone wrong.
				() => setTimeout( () => targetEl.classList.remove( 'en_button--loading' ), 10000 ),
			);
		} else {
			// When the transfer cookie is not needed, we just navigate to href.
			this.popupEl.querySelectorAll( '.choose-lang' ).forEach( ( buttonEl ) => buttonEl.classList.toggle( 'en_button--loading', buttonEl === targetEl ) );
			window.location.href = targetEl.getAttribute( 'href' );
		}
	}

	checkLanguage() {
		const current = document.documentElement.lang.slice( -2 ).toLowerCase();
		const cookie = Cookies.get( COOKIE_NAME );

		if ( ( cookie && cookie === current ) || window.EN_KO.functions.isMobileApp() ) {
			return Promise.resolve( current );
		}

		// We got redirected via transfer-basket call.
		const buttonEls = this.popupEl.querySelectorAll( '.choose-lang' );
		const allowedReferrers = Object.fromEntries( Array.from( buttonEls ).map( ( buttonEl ) => [ buttonEl.dataset.domain, buttonEl.dataset.country ] ).filter( ( i ) => !! i ) );
		if ( document.referrer in allowedReferrers ) {
			const country = allowedReferrers[ document.referrer ];
			if ( country ) {
				Cookies.set( COOKIE_NAME, current, { expires: 7, secure: true } );
				return Promise.resolve( current );
			}
		}

		return fetch( '/cms/dispatch/popup/country/' ).then( ( response ) => {
			return response.json();
		} ).then( ( country ) => {
			TAO_KOE.console.log( country, current );

			if ( country === current.toUpperCase() ) {
				// Just resolve immediately.
				Cookies.set( COOKIE_NAME, current, { secure: true } ); // Set Cookie just for the session, because no user interaction was needed.
				return Promise.resolve( current );
			}

			// Open Popup and wait for it to resolve.
			return new Promise( ( resolve ) => {
				// Activate fallback for automations
				const isAutomated = navigator.webdriver === true;

				new window.DialogTrigger( () => {
					this.open().then( resolve );
				}, {
					trigger: 'user_action',
					...( isAutomated && { fallbackTimeout: 0 } ),
				} );
			} );
		} );
	}
}

const initLanguagePopup = function( resolve ) {
	TAO_KOE.console.log( 'INIT LANGUAGE POPUP' );

	const popupEl = document.getElementById( 'popup_country_change' );
	if ( popupEl ) {
		popupEl.KOE_Language_Popup ??= new LanguagePopup( popupEl );
		popupEl.KOE_Language_Popup.checkLanguage().then( ( country ) => {
			TAO_KOE.console.log( 'RESOLVE LANGUAGE POPUP: ' + country );
			resolve();
		} );
	} else {
		resolve();
	}
};

// Init.
TAO_KOE.chainReady( 'language.js', initLanguagePopup, 5 );

// Expose.
TAO_KOE.LanguagePopup = LanguagePopup;

// Export.
export {
	LanguagePopup as default,
	initLanguagePopup,
};
